import { Button, Flex } from '@mantine/core';
import { closeModal, openModal } from '@mantine/modals';
import { ModalWarningContent } from '@shared/ui/modal';
import { useNavigate } from 'react-router';

const MODAL_ID = 'confirm-cancel-save-vacancies-templates';

export const useVacanciesTemplatesConfirmCancelSaveModal = () => {
  const navigate = useNavigate();

  const handleClose = () => {
    closeModal(MODAL_ID);
  };

  const handleCancel = () => {
    closeModal(MODAL_ID);

    navigate('/vacancies-templates-list');
  };

  const openConfirmCancelSaveModal = () =>
    openModal({
      modalId: MODAL_ID,
      title: 'Предупреждение',
      children: (
        <Flex direction='column'>
          <ModalWarningContent
            isErorr={false}
            message='Вы не сохранили изменения перед закрытием. Хотите вернуться?'
          />

          <Flex pt={12} gap={8}>
            <Button variant='outline' onClick={handleCancel}>
              Не сохранять
            </Button>
            <Button variant='primary' onClick={handleClose}>
              Вернуться
            </Button>
          </Flex>
        </Flex>
      ),
    });

  return { openConfirmCancelSaveModal };
};
